<script>
import moment from "moment"

export default {
  name: "formCalendar",
  components: {},
  props: {
    //值
    value: {
      type: [Array, String],
      default: () => [],
    },
    //标题
    title: {
      type: String,
      default: "",
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: "",
    },
    //提示
    placeholder: {
      type: String,
      default: "请选择",
    },
    //必填
    required: {
      type: Boolean,
      default: false,
    },
    //只读
    readonly: {
      type: Boolean,
      default: false,
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    //默认时间
    defaultDate: {
      type: Array,
      default: null,
    },
    //最小时间
    minDate: {
      type: [Date, Function, Object],
      default: null,
    },
    //最大时间
    maxDate: {
      type: [Date, Function, Object],
      default: null,
    },
    // isRevise: {
    //   type: Boolean,
    //   default: false
    // },
    //是否可选同一天
    allowSameDay: {
      type: Boolean,
      default: true,
    },
    //类型
    type: {
      String,
      default: "range",
    },
  },
  data() {
    return {
      visible: false,
      initMinDate: moment().toDate(),
      initMaxDate: moment()
        .add(12, "M")
        .toDate(),
      realValue: this.value || (this.type === "single" ? [] : ""),
    }
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e)
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e
      }
    },
  },
  computed: {
    calendarMinDate() {
      let { minDate } = this
      if (minDate && minDate instanceof moment) {
        minDate = minDate.toDate()
      }
      return minDate ? minDate : this.initMinDate
    },
    calendarMaxDate() {
      let { maxDate } = this
      if (maxDate && maxDate instanceof moment) {
        maxDate = maxDate.toDate()
      }
      return maxDate ? maxDate : this.initMaxDate
    },
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e
    },
    /**
     * @description: 打开弹窗
     * @param {*}
     * @return {*}
     */
    popupShow() {
      this.visible = true
    },
    /**
     * @description: 弹窗 确认
     * @param {*} data
     * @return {*}
     */
    confirm(data) {
      if (this.type == "single") {
        data = moment(data).format("YYYY-MM-DD")
      } else {
        data = data.map((p) => moment(p).format("YYYY-MM-DD"))
      }
      this.visible = false
      this.realValue = data
      this.$emit("change", data)
    },
    /**
     * @description: 输入框 渲染
     * @param {*}
     * @return {*}
     */
    fieldRender() {
      let { realValue, readonly, disabled, $scopedSlots } = this
      readonly = readonly || disabled
      let value
      if (realValue instanceof Array) {
        if (realValue.length == 2) {
          value = realValue[0] + " ~ " + realValue[1]
        }
      } else {
        value = realValue
      }
      const option = {
        props: {
          readonly: true,
          value,
          label: this.title,
          labelWidth: this.titleWidth,
          required: this.required,
        },
        ref: "input",
      }
      if (!readonly) {
        option.props.rightIcon = "arrow-down"
        option.props.placeholder = this.placeholder
        option.on = {
          click: this.popupShow,
        }
      }
      if ($scopedSlots.field) {
        let content = $scopedSlots.field(realValue)
        return <div {...{ on: option.on }}>{content}</div>
      }
      return <van-field {...option} />
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    calendarRender() {
      let { realValue } = this
      const option = {
        props: {
          allowSameDay: this.allowSameDay,
          type: this.type,
          showConfirm: false,
          minDate: this.calendarMinDate,
          maxDate: this.calendarMaxDate,
          value: this.visible,
          getContainer: "#app",
        },
        on: {
          input: (e) => {
            this.visible = e
          },
          confirm: this.confirm,
        },
      }
      let defaultDate
      if (realValue instanceof Array) {
        defaultDate =
          realValue.length == 2
            ? [moment(realValue[0]).toDate(), moment(realValue[1]).toDate()]
            : null
        option.props.defaultDate = defaultDate
      } else {
        option.props.defaultDate = realValue ? moment(realValue).toDate() : null
      }
      return <van-calendar {...option} />
    },
  },
  render() {
    return (
      <div class="form-item-wraper">
        {this.fieldRender()}
        {this.calendarRender()}
      </div>
    )
  },
}
</script>
